import React from 'react';
import { connect } from 'react-redux';

import * as API from '../../core/api';
import Item from './Item';
import { requestDataIfNeeded } from './duck';

class List extends React.Component {
  handleUndoCancel = (inviteCode) => {
    API.post(`invites/${inviteCode}`, { status: 'SENT' })
      .then(this.props.getInvites)
      .catch((error) => alert(JSON.stringify(error)));
  };

  handleCancel = (inviteCode) => {
    API.post(`invites/${inviteCode}`, { status: 'CANCELED' })
      .then(this.props.getInvites)
      .catch((error) => alert(JSON.stringify(error)));
  };

  handleEditSuccess = () => this.props.getInvites();

  renderItems = (invites) => {
    return invites.map(
      (invite) =>
        invite && (
          <Item
            onUndoCancel={this.handleUndoCancel}
            onCancel={this.handleCancel}
            onEditSuccess={this.handleEditSuccess}
            key={invite._id}
            invite={invite}
          />
        )
    );
  };

  render() {
    const { invites } = this.props;

    if (!invites) {
      return null;
    }

    return (
      <div className="u-margin-bottom-huge">
        <div className="c-box c-box-primary">
          <div className="">{this.renderItems(invites)}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { getInvites: requestDataIfNeeded };

export default connect(
  null,
  mapDispatchToProps
)(List);



// WEBPACK FOOTER //
// ./src/admin/invites/List.js